// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"tableHeader_tableHeader__248oe","heading":"tableHeader_heading__1Tkgp","subtext":"tableHeader_subtext__1xnM2","selectAll":"tableHeader_selectAll__2WUiA"};